import { ofType, combineEpics, type Epic } from 'redux-observable';
import { from, of } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';

import Safescarf from '../../../api/safescarf';
import { handleError } from '../../errorHandler';
import { enqueueSnackbar } from '../../notifier/actions';
import { fetchProductMembers } from '../productMembers/actions';

import {
  CREATE_SAFESCARF_PRODUCT_STARTED,
  createProductFulfilled,
  FETCH_SAFESCARF_PRODUCTS_STARTED,
  fetchProductsFulfilled,
  UPDATE_SAFESCARF_PRODUCT_STARTED,
  updateProductFulfilled,
  DELETE_SAFESCARF_PRODUCT_STARTED,
  deleteProductFulfilled,
} from './actions';

const createProductEpic: Epic = action$ =>
  action$.pipe(
    ofType(CREATE_SAFESCARF_PRODUCT_STARTED),
    mergeMap((action: { payload: Record<string, unknown> }) =>
      from(Safescarf.createSafescarfProduct(action.payload)).pipe(
        mergeMap((response: { data: unknown }) =>
          of(
            createProductFulfilled(response.data),
            fetchProductMembers(),
            enqueueSnackbar({
              message: 'safescarfProductCreated',
              options: { variant: 'success' },
            })
          )
        ),
        catchError(handleError)
      )
    )
  );

const fetchProductsEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_SAFESCARF_PRODUCTS_STARTED),
    mergeMap((action: { payload: unknown }) =>
      from(Safescarf.fetchSafescarfProducts(action.payload)).pipe(
        mergeMap((response: { data: unknown }) => of(fetchProductsFulfilled(response.data))),
        catchError(handleError)
      )
    )
  );

const updateProductEpic: Epic = action$ =>
  action$.pipe(
    ofType(UPDATE_SAFESCARF_PRODUCT_STARTED),
    mergeMap((action: { payload: Record<string, unknown> & { id: string; } }) =>
      from(Safescarf.updateSafescarfProduct(action.payload)).pipe(
        mergeMap((response: { data: unknown }) =>
          of(
            updateProductFulfilled(response.data),
            enqueueSnackbar({
              message: 'safescarfProductUpdated',
              options: { variant: 'success' },
            })
          )
        ),
        catchError(handleError)
      )
    )
  );

const deleteProductEpic: Epic = action$ =>
  action$.pipe(
    ofType(DELETE_SAFESCARF_PRODUCT_STARTED),
    mergeMap((action: { payload: string }) =>
      from(Safescarf.deleteSafescarfProduct(action.payload)).pipe(
        mergeMap(() =>
          of(
            deleteProductFulfilled(action.payload),
            enqueueSnackbar({
              message: 'safescarfProductDeleted',
              options: { variant: 'success' },
            })
          )
        ),
        catchError(handleError)
      )
    )
  );

export default combineEpics(
  createProductEpic,
  fetchProductsEpic,
  updateProductEpic,
  deleteProductEpic
);
